import React from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router';
import { addQuickApp } from '../../../redux/applications/actions/AppActions';

import CreateAppModal from './CreateAppModal';
import { QuickAppType } from '../../../interfaces/quickApp';
import { useOrg } from '../../../helpers/customHooks';

type PropsType = { open: boolean; onClose: () => void };

const CreateAppModalWrapper: React.FC<PropsType> = ({ onClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const organisation = useOrg();

  const onQuickCreate = (newApp: QuickAppType) => {
    dispatch(addQuickApp(newApp));
    history.push(`/projects/details/${newApp.id}`, { newApp: true });
  };

  return (
    <CreateAppModal
      onClose={onClose}
      onCreate={onQuickCreate}
      userDetails={
        organisation?.name && organisation?.country
          ? { company: organisation.name, country: organisation.country }
          : undefined
      }
    />
  );
};

export default CreateAppModalWrapper;
